import {
  FaAppleAlt,
  FaHeartbeat,
  FaUserMd,
  FaNotesMedical,
  FaDumbbell,
  FaWeight,
} from "react-icons/fa";
import { motion } from "framer-motion";

const ScreenFour = () => {
  const services = [
    {
      title: "Healthy Weight Management",
      des: "Achieve your ideal weight safely with personalized plans that boost confidence and overall wellness.",
      icon: <FaWeight className="text-[#020046] w-10 h-10 mb-4" />,
    },
    {
      title: "Weight Gain Support",
      des: "Support for underweight individuals to reach a healthy BMI with nutrition guidance and lifestyle advice.",
      icon: <FaAppleAlt className="text-[#020046] w-10 h-10 mb-4" />,
    },
    {
      title: "Body Sculpting & Figure Correction",
      des: "Tailored programs to help you achieve a balanced, healthy body shape with sustainable results.",
      icon: <FaDumbbell className="text-[#020046] w-10 h-10 mb-4" />,
    },
    {
      title: "Therapeutic Diet Plans",
      des: "Customized diets designed to manage PCOD symptoms, hormonal imbalances, and other metabolic disorders.",
      icon: <FaHeartbeat className="text-[#020046] w-10 h-10 mb-4" />,
    },
    {
      title: "Personalized Patient Care",
      des: "Comprehensive care with a focus on comfort, dignity, and highest medical standards for every patient.",
      icon: <FaUserMd className="text-[#020046] w-10 h-10 mb-4" />,
    },
    {
      title: "Digital Medical Records",
      des: "Secure electronic health records for easy access to your medical history, lab results, and treatment plans.",
      icon: <FaNotesMedical className="text-[#020046] w-10 h-10 mb-4" />,
    },
  ];

  return (
    <section id="services" className="py-20 px-6 md:px-10">
      <div className="max-w-4xl mx-auto text-center mb-12">
        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.3, delay: 0.2, ease: "easeOut" }}
          className="text-5xl text-pink-600 my-12"
        >
          Services
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.3, delay: 0.2, ease: "easeOut" }}
          className="text-gray-700 text-lg leading-relaxed mb-6"
        >
          At{" "}
          <span className="font-semibold text-pink-600">Glow PCOD Clinic</span>,
          we offer a wide range of services to support women in managing PCOD.
          From nutrition and weight management to fertility care and counseling,
          our services are designed to heal the body and mind together.
        </motion.p>
      </div>

      <motion.div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              opacity: { duration: 0.3, delay: index * 0.2, ease: "easeOut" },
              y: { duration: 0.3, delay: index * 0.2, ease: "easeOut" },
            }}
            whileHover={{
              scale: 1.05,
              transition: { duration: 0.2, delay: 0 },
            }}
            whileTap={{
              scale: 0.95,
              transition: { duration: 0.2, delay: 0 },
            }}
            className="p-6 bg-white rounded-lg shadow-md shadow-gray-300 flex flex-col items-start"
          >
            {item.icon}
            <h3 className="text-xl font-bold text-[#020046] mb-2">
              {item.title}
            </h3>
            <p className="text-gray-600 text-sm">{item.des}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default ScreenFour;
